import { IconButton } from '@mui/material';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useTheme } from 'styled-components';

import { typeAnimalFigurant, typeChildFigurant, typeVehicleFigurant } from 'components/modules/FigurantCard/constants';
import { cpfMask } from 'commons/utils';
import { findDocument } from 'commons/utils/figurant';
import { DocumentType } from 'commons/constants/documents';

import { IFigurantSelected } from '../../@types';
import * as S from '../../styles';

export type Props = {
  item: IFigurantSelected;
  type: string;
  removeFigurant: (objFigurant: { id: number }) => void;
};

const getDocumentCPF = (src: any, type: string) => {
  const documentCPF = type !== typeChildFigurant ? findDocument(src as [], DocumentType.CPF)?.documentContent : src;
  return cpfMask(documentCPF);
};

export const FigurantSelected = ({ item, type, removeFigurant }: Props) => {
  const theme = useTheme();
  const typeIsVehicleOrAnimal = type === typeVehicleFigurant || type === typeAnimalFigurant;

  const findBackgroundActors =
    item?.backgroundActors?.length > 1
      ? item.backgroundActors?.find(backgroundActor => backgroundActor.isResponsible)
      : item?.backgroundActors?.[0];

  const responsible = typeIsVehicleOrAnimal ? findBackgroundActors : null;

  const typeFigurantLabel: Record<string, string> = {
    '1': `${getDocumentCPF(item.documents, type)} - ${item.name}`, // 'normal
    '2': `${item?.model} - ${responsible?.name} - ${getDocumentCPF(responsible?.documents, type)}`, // veiculo
    '3': `${item?.animalBreed} - ${responsible?.name} - ${getDocumentCPF(responsible?.documents, type)}`, // animal
    '4': `${getDocumentCPF(item.documents, type)} - ${item.name}`, // menor
    '5': `${getDocumentCPF(item.cpf, type)} - ${item.name}`, // 'fiscal'
    '8': `${getDocumentCPF(item.documents, type)} - ${item.name}`, // modelo profissional
    '9': `${getDocumentCPF(item.documents, type)} - ${item.name}`, // auxiliar plateia

  };

  return (
    <S.Item>
      <S.Column>
        <S.Label title={item?.model}>{typeFigurantLabel[type]}</S.Label>
      </S.Column>
      <S.Column>
        <IconButton data-testid="button-to-remove-figurant" onClick={() => removeFigurant({ id: item.id })}>
          <DeleteOutlineOutlinedIcon htmlColor={theme.palette.primary.dark} />
        </IconButton>
      </S.Column>
    </S.Item>
  );
};
